import { IStore } from '../store';

export const getEvents = (state: IStore) => state.Calendar.events;
export const getEvent = (id: string | null) => (state: IStore) => state.Calendar.events.find(e => e.id === Number(id));
export const getCalendars = (state: IStore) => state.Calendar.calendars;

export const getAllCalendarColor = (state: IStore) => state.App.settings.calendar;
export const getCalendarColor = (id: string | undefined) => (state: IStore) =>
  id ? state.App.settings.calendar?.[id] : null;
